import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
// import App from '@/App.vue';

Vue.use(VueRouter)

const routes = [
    {
        path: '/home',
        name: 'home',
        component: Home,
        meta: {
            title: 'AHA Header Footer Markup'
        }
    },
    {
        path: '*',
        name: 'catchAll',
        component: Home
    }
]

const router = new VueRouter({
    // mode: 'history',
    base: process.env.BASE_URL,
    routes
  })

  export default router




